import React, { useEffect, useState } from "react";
import "./Partners.css";
import { Container, Flex, Header, SafeArea } from "../../components/layout";
import { Image, Text } from "../../components/ui";
import { TbArrowRight } from "react-icons/tb";
import { Link } from "react-router-dom";

import User from "../../assets/images/partners/User.png";
import { collection, getDocs, orderBy, query } from "firebase/firestore";
import { db } from "../../components/firebase/firebase";
import { logEvent, serializeError } from "../../utils/logger";

function Partners() {
  const [data, setData] = useState([]);

  const fetchArticles = async () => {
    try {
      let dataQuery = query(
        collection(db, "partners"), // ✅ Utilisation correcte de collection()
        orderBy("title"), // ✅ Tri par date descendante
      );

      const querySnapshot = await getDocs(dataQuery); // ✅ Récupération des documents
      querySnapshot.forEach((doc) => {
        setData((data) => [...data, { id: doc.id, ...doc.data() }]);
      });
    } catch (error) {
      console.error("Erreur lors du chargement des articles :", error);
      logEvent("ERROR", "DB", "Failed to fetch partners list", {
        error: serializeError(error),
        collection: "partners",
      });
    }
  };
  useEffect(() => {
    fetchArticles();
  }, []);
  return (
    <SafeArea className="Partners">
      <Flex type="col-center">
        <Header
          title="Nos partenaires"
          text="Nos partenaires de confiance inspirés par l'esprit de l'Ecrin Sauvage."
        />
        <Flex type="col" className="wrapper">
          {data.map((data, index) => (
            <Link
              key={index}
              to={`/partenaire/${data.id}`}
              className={"container"}
            >
              <Flex type="between-center">
                <Flex gap={20}>
                  <Image
                    src={data.pictureprofile ?? User}
                    alt={data.title + " - " + data.activity}
                  />
                  <Container className="ctn-text">
                    <Text>{data.title}</Text>
                    <Text size="xs">{data.activity}</Text>
                  </Container>
                </Flex>
                <TbArrowRight className="icon" />
              </Flex>
            </Link>
          ))}
        </Flex>
      </Flex>
    </SafeArea>
  );
}

export default Partners;
